//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { subtract, multiply, round, assign, cloneDeep, getSeconds, flashAnimate, langFn, matomofn } from '~/assets/js/utils.js'
export default {
  components: {
    'bread-crumbs': () => import('~/components/common/breadCrumbs.vue'),
    'two-bar': () => import('~/components/home/sentiment/twoBar.vue'),
    'mobile-tab': () => import('~/components/common/mobileTab.vue')
  },
  async asyncData ({ store, $api }) {
    const { locale = 'en' } = store.state
    try {
      const { list = [] } = await $api.common.invokeServer({ HttpMethod: 'post', Route: '/mt4Extend/longShortRate' }, { symbol: 'EURUSD', languageCode: langFn(locale) })
      return {
        moodList: list || []
      }
    } catch (err) {}
  },
  data () {
    return {
      // 页面
      optionList: [{ name: 'EUR/USD' }, { name: 'GBP/USD' }, { name: 'AUD/USD' }, { name: 'NZD/USD' }, { name: 'USD/JPY' }, { name: 'USD/CAD' }, { name: 'USD/CHF' }, { name: 'XAU/USD' }], // 下拉选项列表
      moodList: [], // 接口返回的交易商列表
      // 弹框
      showEmoDialog: false, // 是否展示弹框
      emoSelectedImg: '', // 交易商图片
      emoSelectedName: '', // 交易商名称
      emoTab: 1, // tab选中项
      emoApi: [], // 接口返回的列表项
      holdList: [], // 处理后的列表项
      updateTime: getSeconds(), // 更新时间
      dialogTime: getSeconds(), // 更新时间
      pageEnterTime: null // 页面进入时间
    }
  },
  head () {
    return {
      title: this.$t('19814'),
      meta: [
        { name: 'Keywords', content: this.$t('TYY_000646') },
        { name: 'Description', content: this.$t('19815') }
      ]
    }
  },
  computed: {
    // 是否为移动端
    isM () {
      return this.$store?.state?.isMobile
    },
    // 当前屏幕的宽度
    equipWidth () {
      return this.$store?.state?.screenWidth || 0
    },
    // 柱子文本展示最小值
    minNum () {
      return this.equipWidth >= 1200 ? 8 : (this.equipWidth >= 1000 ? 10 : (this.equipWidth >= 800 ? 15 : 30))
    }
  },
  created () {
    this.moodList = this.dealMoodData(cloneDeep(this.moodList))
  },
  mounted () {
    // 记录页面进入时间
    this.pageEnterTime = Date.now()
    // 监听页面关闭事件
    window.addEventListener('beforeunload', this.trackPageTime)

    this.flickerTimer = setTimeout(this.flashAniFn, 5000)
  },
  beforeDestroy () {
    // 页面销毁前移除事件监听器
    window.removeEventListener('beforeunload', this.trackPageTime)
    // 执行页面时间统计
    this.trackPageTime()

    clearTimeout(this.flickerTimer)
    clearTimeout(this.lightTimer)
  },
  methods: {
    // 页面时间统计
    trackPageTime () {
      if (this.pageEnterTime) {
        const { type = 1 } = this.$route.query
        const fnText = type == 2 ? 'Cloud_Volume_Time' : 'Cloud_Sentiment_Time'
        const exitTime = Date.now()
        matomofn(fnText, {
          af_Enter: this.pageEnterTime,
          af_Exit: exitTime
        }, this.$store.state, this.$cookies)
      }
    },
    // 下拉选项改变时
    async changeMoodFn ({ name = '' }) {
      const symbol = name?.replace('/', '')
      try {
        const { list = [] } = await this.$api.common.invokeClient({ HttpMethod: 'post', Route: '/mt4Extend/longShortRate' }, { symbol, languageCode: langFn(this.currLangCode()) })
        this.moodList = this.dealMoodData(cloneDeep(list || []))
        clearTimeout(this.flickerTimer)
        this.flickerTimer = setTimeout(this.flashAniFn, 5000)
      } catch (err) {}
    },
    // 处理接口返回的数据
    dealMoodData (arr = []) {
      arr?.forEach((item) => {
        item.red = round(multiply(item.longNumRate || 0, 100), 2)
        item.green = round(multiply(item.shortNumRate || 0, 100), 2)
        item.active = false
      })
      return arr
    },
    // 高亮某几个横条
    flashAniFn () {
      clearTimeout(this.flickerTimer)
      this.moodList = flashAnimate(this.moodList)
      this.updateTime = getSeconds() // 更新时间
      this.flickerTimer = setTimeout(this.flashAniFn, 5000)
    },
    // 弹框——打开弹框
    async openEmoFn (obj = {}) {
      const { brokerId = '', brokerIcon = '', brokerName = '' } = obj
      if (brokerId?.toLowerCase() == 'all') return false
      if (this.isM) { // 手机端不展示弹框，而是跳转页面
        window?.open(`/${this.currLangCode()}/data/holdpositiondetails.html?id=${brokerId}&icon=${brokerIcon}&name=${brokerName}`)
        return true
      }
      this.emoSelectedImg = brokerIcon
      this.emoSelectedName = brokerName
      this.showEmoDialog = true
      try {
        const { tianyancenter = {} } = await this.$api.home.sentimentCurrencyClient({ HttpMethod: 'post', Routes: 'tianyancenter$dkqx' }, { broker_id: brokerId })
        this.emoApi = (tianyancenter?.dkqx?.data?.data || [])
        this.dialogTime = getSeconds()
        this.holdList = this.dealEmoData(this.emoApi, subtract(this.emoTab, 1))
        this.lightTimer = setTimeout(this.twinkleFn, 5000)
      } catch (err) {}
    },
    // 弹框——切换tab
    emoTabsFn (value = 1) {
      this.emoTab = value
      this.holdList = this.dealEmoData(this.emoApi, subtract(value, 1))
      clearTimeout(this.lightTimer)
      this.lightTimer = setTimeout(this.twinkleFn, 5000)
    },
    // 弹框——处理接口返回的数据
    dealEmoData (arr = [], tabIdx = 0) {
      const resultArr = []
      arr?.forEach((item, index) => {
        item.red = round(multiply(item[tabIdx < 1 ? 'longNumRate' : 'longLotsRate'], 100), 2)
        item.green = round(multiply(item[tabIdx < 1 ? 'shortNumRate' : 'shortLotsRate'], 100), 2)
        assign(item, { id: String(index + 1), nameEn: item.symbol, label: item.symbol, active: false })
        resultArr.push(item)
      })
      return resultArr
    },
    // 弹框——高亮某几个横条
    twinkleFn () {
      clearTimeout(this.lightTimer)
      this.holdList = flashAnimate(this.holdList)
      this.dialogTime = getSeconds() // 更新时间
      this.lightTimer = setTimeout(this.twinkleFn, 5000)
    },
    // 弹框——关闭弹框
    closeEmoFn () {
      this.showEmoDialog = false
      this.emoTab = 1 // 恢复到第一个tab
      this.emoApi.length = this.holdList.length = 0 // 清空数组
      clearTimeout(this.lightTimer) // 清除延时器
    }
  }
}
